<template>
   <div>

      <v-autocomplete ref="myAutocomplete"
         v-model="options.initial"
         :items="items"
         :loading="isLoading"
         :search-input.sync="search"
         chips
         hide-details
         auto-select-first
         deletable-chips
         :required="options.required"
         :disabled="options.disabled"
         :hide-selected="options.hide_selected"
         :clearable="options.clearable"
         :multiple="options.multiple"
         :item-text="options.item_text"
         :item-value="options.item_value"
         :item-disabled="options.item_disabled"
         :label="options.label"
         :filter="filterMethod"
         v-on:change="change"
      >

         <template v-slot:selection="data">
            <slot name="selection" :item="data.item" :selected="data.selected" :attrs="data.attrs" :on="data.on" v-scope="data">
               <p>???</p>
            </slot>
         </template>

         <template v-slot:item="data">
            <slot name="item" :item="data.item" v-scope="data">
               <p>???</p>
            </slot>
         </template>

      </v-autocomplete>

    </div> 
</template>

<script>
export default {
   name: 'ddoSelect',
   props: {
      callbacks: {
         type: Object,
         default: function () {
            return {};
         }
      },
      options: {
         type: Object,
         default: function () {
            return {
               initial: null,
               disabled: false,
            };
         }
      },
   },
   data: () => {
      return {
         isLoading: false,
         items: [],
         selected: [],
         model: null,
         search: null,
         tab: null,
         filterMethod : null,
      }
   },

   created() {
   },

   async mounted() {
      console.log('ddoSelect::mounted()');
      if ( this.callbacks.filterMethod ) {
       this.filterMethod = this.callbacks.filterMethod; 
      } else {
       this.filterMethod = this.defaultfilterMethod; 
      }
      await this.refresh_rows();
      this.$emit('itemsLoaded',this.items);
   },

   methods: {

      defaultfilterMethod(item, queryText, itemText) {
         return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      },

      async refresh_rows(key=null) {
         if ( typeof this.callbacks.refresh_rows == 'function' ) {
            var { errorinfos, api_response } = await this.callbacks.refresh_rows(key);
            if ( api_response.error==0 && api_response.rows ) {
               var raw_rows = api_response.rows;
            } else {
               var raw_rows = [];
            }
            this.items = raw_rows;
         }
         console.log('ddoSelect::refresh_rows() FINISHED');
      },

      remove(item) {
         //console.log('remove, item='+JSON.stringify(item))
         //console.log('remove, initial='+JSON.stringify(this.options.initial))
         if ( typeof item._pk != "undefined" ) {
            if ( typeof this.callbacks.remove == 'function' ) {
               this.callbacks.remove(item);
            }
            this.$api._remove_by_pk(this.items,item._pk);
            //this.$api._remove_by_pk(this.options.initial,item._pk);
         }
      },

      async change(value,item=null) {
         console.log('parent change, value='+JSON.stringify(value));
         // item is supposed to be NULL. We have to find it
         if ( item==null ) {
            item = this.$api._get_by_pk(this.items,value);
         }
         console.log('parent change, item='+JSON.stringify(item));
         if ( typeof this.callbacks.change == 'function' ) {
            console.log('change, call callback, value='+JSON.stringify(value));
            await this.callbacks.change(value,item);
         }
      },

   },

}
</script>